import styled from "styled-components";

import { SPACING } from "../../../utils/constants";

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.sm}px;
  flex-wrap: wrap;
`;

export const StatusFilter = styled.div`
  min-width: 200px;
`;
